import { useParams } from "react-router-dom";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory"
import { PublicacaoDiarioOficialProvider } from "./context/publicacao-diario-oficial-context"
import { PublicacaoDiarioOficial } from "./publicacao-diario-oficial"

export const PublicacaoDiarioOficialFactory = () => {
    const { publicationShipmentId } = useParams();
    return (
        
        <BaseInternalFormFactory pageTitle={`Diagramar Diário Oficial ${publicationShipmentId !== undefined ? ' / Remessa Nº ' + publicationShipmentId : ''}`}>
            <PublicacaoDiarioOficialProvider>
                <PublicacaoDiarioOficial />
            </PublicacaoDiarioOficialProvider>
        </BaseInternalFormFactory>
    )
}